export enum OsmType {
	NoOSM = 0,
	ISAY = 1,
	InternalAndExternalSample = 2,
	SampleOne = 3,
	Unknown = 4
}
